import { render, staticRenderFns } from "./LowCarbon.vue?vue&type=template&id=0f28028f&scoped=true&"
import script from "./LowCarbon.vue?vue&type=script&lang=js&"
export * from "./LowCarbon.vue?vue&type=script&lang=js&"
import style0 from "./LowCarbon.vue?vue&type=style&index=0&id=0f28028f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28028f",
  null
  
)

export default component.exports